import { Injectable } from '@angular/core';

import { SessionStorage } from './storage/session';
import { StorageToken } from 'core/constants';
import { Transition } from '@uirouter/core';

@Injectable({
    providedIn: 'root'
})
export class CimaAuthGuidService {
    private sessionStorage: SessionStorage;

    constructor(sessionStorage: SessionStorage) {
        Object.assign(this, { sessionStorage });
    }

    public init(transition: Transition): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const params: { [key: string]: any } = transition.params();
        const accQuery: string = params.acc;
        const osQuery: string = params.os;

        const tenantId: string = osQuery ? 'ORION' : undefined;
        if (tenantId) {
            this.sessionStorage.set(StorageToken.X_TENANT_ID, tenantId);
        }
        
        if (!accQuery && !osQuery) {
            return;
        }
        const authGuid: string = osQuery ?? accQuery;

        this.sessionStorage.set(StorageToken.CIMA_USER_ACCOUNT_GUID, authGuid);
    }
}

